<template>
  <section class="panel">
    <h2>My Journey</h2>
    <div v-if="studentTerms.length">
      <div class="term" v-for="term, index in studentTerms" :key="term.id" :style="{'--height': term.height}">
        <div class="center-line"></div>
        <div class="term-name">
          <!-- {{`Term ${index + 1} - `}}{{ term.type | capitalize }} -->
          Start of Your Think Tank Journey
        </div>
        <div class="events">
          <div v-for="event in term.events" class="event" :class="{'you-are-here': event.name == 'you_are_here', glowing: openEvent == event.id || glowing == event.id}" :style="{'--top': event.top, '--width': event.width, '--drop': event.drop, '--height': event.height, '--shift': event.shift, '--color': event.status.color, '--z-index': event.status.level, '--tcolor': event.status.tcolor}" :key="event.id">
            <div class="title" @click="openEvent == event.id ? openEvent = -1 : openEvent = event.id" @mouseover="glowing = event.id" @mouseleave="glowing = -1">
              <strong class="capitalize" v-if="event.name.includes('Term Start')">{{event.name}}</strong><span v-else>{{event.name}} {{event.status.msg}}</span>
              <div v-if="openEvent == event.id && (event.description || event.media || event.link)" class="event-content">
                <i class="fa fa-remove" @click.stop="openEvent = -1"></i>
                <div class="media" v-if="event.media">
                  <video @click.stop="openVideo = event.media" v-if="event.media.includes('.mp4')">
                    <source :src="event.media">
                  </video>
                  <img v-else :src="event.media" @click.stop="openImage = event.media ">
                </div>
                <div v-if="event.description">{{event.description}}</div>
                <div class="bottom-row">
                  Due: <span v-html="$options.filters.journeyDate(event.end)"></span>
                  <a @click.stop v-if="event.link" :href="event.link" target="_blank">Read More</a>
                </div>
              </div>
            </div>
            <div class="borders" :class="{hasDuration: event.duration}"></div>
            <div v-if="!event.hideStart" class="startDate" v-html="$options.filters.journeyDate(event.start)"></div>
            <div v-if="!event.hideEnd" class="endDate" v-html="$options.filters.journeyDate(event.end)"></div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <Loader></Loader>
    </div>

    <div class="lightbox" v-if="openVideo || openImage" @click="openVideo=null;openImage=null">
      <i class="fa fa-remove"></i>
      <video @click.stop v-if="openVideo" controls>
        <source :src="openVideo" />
      </video>
      <img @click.stop v-if="openImage" :src="openImage">
    </div>
  </section>
</template>

<script>
import journeys from "../services/journeys";
import terms from "../services/terms";
import moment from "moment";
import Loader from "./reusable/forum/loader.vue";

export default {
  data() {
    return {
      terms: null,
      journeys: null,
      studentTerms: [],
      myJourney: null,
      openVideo: null,
      openImage: null,
      openEvent: -1,
      glowing: -1,
    };
  },
  components: {
    Loader
  },
  async mounted() {
    //get terms
    let t = await terms.get(this);
    this.terms = t.data.terms;

    //get journeys
    let j = await journeys.getEvents(this);
    this.myJourney = j.data.journey.data;

    //add term, start date, and you are here
    j.data.terms.forEach((id) => {
      let term = this.terms.find((t) => t.id == id);
      let termType = term.type;      
      
      if (termType === 'foundation') { termType = 'fundamentals'}
      if (termType === 'mentorship') { termType = 'portfolio production'}
      
      let events = [
        {
          name: `${termType} Term Start`,
          start: moment(term.startDate),
          end: moment(term.startDate),
          description: `Start of your ${termType} term!`,
        },
      ];

      //add you're here event if you're here!
      if (
        this.$store.getters.currentTerm &&
        term.type == this.$store.getters.currentTerm.type
      )
        events.push({
          name: "you_are_here",
          start: moment(),
          end: moment(),
        });

      this.studentTerms.push({
        type: term.type,
        startDate: moment(term.startDate),
        events: events,
        records: {},
      });
    });

    //add events to terms and give them start/end dates

    let journeyEvents = j.data.events;

    if (localStorage.path && localStorage.path == '9200') {      
      // if the student is in the Houdini path, remove the pickPath event.
      // Students in this path cannot change their path.      
      journeyEvents = journeyEvents.filter(j => j.actionName !== 'pickPath');
    }

    const enrollments = this.$store.getters.enrollments;
    const selectedEnrollment = enrollments.find(e => e.id === parseInt(localStorage.enrollment));
    if (selectedEnrollment) {      
      if (selectedEnrollment.programId === '1d8cb5a0-13b5-4ee1-a9a7-9c29566c0bbc') {
        journeyEvents = journeyEvents.filter(j => j.actionName !== 'pickPath');      
      }
    }



    journeyEvents.forEach((event) => {
      let term = this.studentTerms.find((t) => t.type === event.termType);

      if (term) {
        event.duration = event.duration || 0;
        event.start = moment(term.startDate).add(
          event.timeFromStart,
          event.timeUnit
        );
        event.end = moment(event.start).add(event.duration, "days");

        if (
          (event.name.includes("Winter") &&
            event.start.isAfter(moment(term.startDate).dayOfYear(274)) &&
            event.end.isBefore(moment(term.startDate).dayOfYear(396))) ||
          (event.name.includes("Spring") &&
            event.start.isAfter(moment(term.startDate).dayOfYear(32)) &&
            event.end.isBefore(moment(term.startDate).dayOfYear(150))) ||
          (event.name.includes("Summer") &&
            event.start.isAfter(moment(term.startDate).dayOfYear(151)) &&
            event.end.isBefore(moment(term.startDate).dayOfYear(273))) ||
          (!event.name.includes("Winter") &&
            !event.name.includes("Summer") &&
            !event.name.includes("Spring"))
        )
          term.events.push(event);
      }
    });

    if (this.studentTerms.length > 1)
      while (this.studentTerms.length > 1)
        this.studentTerms[0].events = [
          ...this.studentTerms[0].events,
          ...this.studentTerms.pop().events,
        ];

    this.studentTerms.forEach((term) => {
      term.events.sort((a, b) => {
        if (a.start.isSame(b.start)) return b.end.isAfter(a.end) ? 1 : -1;
        return a.start.isAfter(b.start) ? 1 : -1;
      });
    });

    this.studentTerms.forEach((term) => {
      term.events.forEach((event) => {
        let sd = event.start.valueOf()
        let ed = event.end.valueOf()

        if (!term.records[sd])
          term.records[sd] = {
            width: 1,
            count: 1,
            drop: 0,
            shift: 0,
            hideTitle: false,
          };
        else
          term.records[sd].count += sd == ed ? 0 : 1;

        if(!term.records[ed])
          term.records[ed] = {
            width: 1,
            count: 0,
            drop: 0,
            shift: 0,
            hideTitle: false,
          };
      });
      term.sorted = Object.keys(term.records).sort();
    });

    this.solveEvents();
  },
  methods: {
    solveEvents() {
      this.studentTerms.forEach((term) => {
        let sorted = term.sorted;
        let records = term.records;

        term.events.forEach((event) => {
          let sd = event.start.valueOf().toString();
          let ed = event.end.valueOf().toString();

          event.hideStart = records[sd].hideTitle;
          records[sd].hideTitle = true;
          event.hideEnd = records[ed].hideTitle;
          records[ed].hideTitle = true;

          event.top = sorted.indexOf(sd) + 1;
          event.height = sorted.indexOf(ed) - event.top + 1;
          event.shift = records[sd].shift + records[sd].count;
          event.width = records[sd].width++;
          event.drop = records[sd].drop++;
          for (let i = sorted.indexOf(sd) + 1; i <= sorted.indexOf(ed); i++) {
            records[sorted[i]].width = records[sd].width;
            if(records[sorted[i]].shift < records[sd].width)
              records[sorted[i]].shift = records[sd].width - 1;
          }

          event.status = this.getColors(event);

          term.height = Math.max(term.height || 1, sorted.indexOf(ed) + 2);
        });
      });
    },
    getColors(event) {
      let now = moment();
      if (this.myJourney[event.actionName] === true)
        return {
          color: "#6fc38f",
          tcolor: "#6fc38f",
          level: 1,
          msg: `(complete)`,
        };

      if (event.start.isBefore(now) && now.isBefore(event.end))
        return {
          color: "#f7ec13",
          tcolor: "#f7ec13",
          level: 2,
          msg: `(due in ${event.end.diff(now, "days")} days)`,
        };

      if (event.start.isAfter(now))
        return {
          color: "#3cf",
          tcolor: "#b0b0b0",
          level: 0,
          msg: event.duration ? `(${event.duration} days)` : "",
        };

      if (!event.actionName)
        return { color: "#6fc38f", tcolor: "#6fc38f", level: 1, msg: "" };

      return {
        color: "#ed2024",
        tcolor: "#ed2024",
        level: 3,
        msg: "(overdue)",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.panel {
  background: #222;
  box-shadow: none;
  padding-bottom: 10rem;

  h2 {
    color: #b0b0b0;
    text-align: center;
    font-size: 4em;
    font-weight: 100;
    height: auto;
    line-height: auto;
    margin-bottom: 3rem;
  }

  .term {
    display: flex;
    justify-content: center;
    height: calc(var(--height) * 70px - 14px);
    background: #222222;
    position: relative;

    .center-line {
      border-right: solid 2px #3cf;
      width: 50%;
    }

    .term-name {
      position: absolute;
      font-weight: 600;
      font-size: 1.5em;
      left: calc(50% + 20px);
      top: -6px;
      z-index: 1;

      &::before {
        content: "";
        width: 16px;
        height: 16px;
        background: #3cf;
        position: absolute;
        border-radius: 50%;
        left: -29px;
        top: 6px;
      }
    }

    .events {
      position: relative;
      width: 50%;

      .event {
        position: absolute;
        width: calc(var(--width, 1) * 10px);
        height: calc(var(--height, 0) * 70px);
        top: calc(var(--top, 0) * 70px);

        &.you-are-here {
          border-bottom: 1px dashed #3cf;
          width: 300px;
          left: -150px;
          animation: glow 800ms ease-out infinite alternate;

          .title,
          .startDate,
          .endDate,
          .borders {
            display: none;
          }
        }

        @keyframes glow {
          0% {
            box-shadow: 0px 0 7px rgba(51, 204, 255, 0.493),
              0px 0 7px rgba(51, 204, 255, 0.5) inset;
          }
          100% {
            box-shadow: 0px 0 15px rgba(51, 204, 255, 0.5),
              0px 0 15px rgba(51, 204, 255, 0.5) inset;
          }
        }

        &.glowing {
          animation: glow 2000ms ease-out infinite alternate;

          .borders {
            z-index: 10000;
            --color: #3cf;

            &.hasDuration {
              background: #222222b0;
            }

            &::before,
            &::after {
              z-index: 10000;
            }
          }

          .title {
            --tcolor: #3cf;
          }
        }

        .borders {
          position: absolute;
          width: 100%;
          top: -1px;
          bottom: -1px;
          border-top: solid 2px transparent;
          border-right: solid 2px transparent;
          border-bottom: solid 2px transparent;

          &.hasDuration {
            border-top: solid 2px var(--color);
            border-bottom: solid 2px var(--color);
            border-right: solid 2px var(--color);

            &::after {
              bottom: -6px !important;
              display: block;
            }
          }

          &::before,
          &::after {
            content: "";
            width: 10px;
            height: 10px;
            background: var(--color);
            position: absolute;
            border-radius: 50%;
            left: -6px;
            z-index: var(--z-index);
          }

          &::before {
            top: -6px;
          }

          &::after {
            display: none;
          }
        }

        .title {
          position: absolute;
          left: calc(var(--shift, 1) * 10px + 7px);
          top: calc(var(--drop, 0) * 20px - 10px);
          width: 400px;
          color: var(--tcolor);
          cursor: pointer;

          strong {
            position: relative;
            font-size: 18px;
            text-transform: capitalize;
            top: -2px;
          }

          .event-content {
            position: relative;
            top: -6px;
            left: -3px;
            color: #b0b0b0;
            padding: 1rem;
            background: #333;
            margin-top: 1rem;
            z-index: 10;

            .fa-remove {
              float: right;
              cursor: pointer;
              top: -0.5rem;
              position: relative;
              right: -0.5rem;
            }

            .media {
              width: 100px;
              height: 100px;
              float: left;
              margin: 0 2rem 1rem 0;

              video,
              img {
                width: 100px;
                height: 100px;
                object-fit: cover;
                cursor: pointer;
              }
            }

            .bottom-row {
              display: flex;
              width: 100%;
              justify-content: space-between;
              margin-top: 1rem;
            }
          }
        }

        .startDate,
        .endDate {
          position: absolute;
          left: -170px;
          width: 150px;
          text-align: end;
        }

        .startDate {
          top: -10px;
        }
        .endDate {
          bottom: -10px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Journey.vue?6ec768fe